'use strict';

namespace core {

    class Tag {
        title: string;
        isNew :boolean;

        public constructor(title, isNew) {
            this.title = title;
            this.isNew = isNew;
        }
    }

    class ExtendableTagList {

        private readonly formName :string;
        private analyticsTag :string;
        private tags :string[];

        public readonly componentInputId :string;
        public readonly inputLabelText :string;
        public readonly labelText :string;
        public readonly maxExtraTags :number;
        public readonly maxTagLength :string;
        public readonly minTagLength :string;

        public form :ng.IFormController;
        public model :string[];
        public newTagTitle :string = '';
        public tagLists :{ predefined :Tag[], userDefined :Tag[] } = { predefined: [], userDefined: []};


        constructor(private $scope : ng.IScope,
                    private analytics : any) {
            let uniqueId = Math.random().toString(36).substr(2, 7);
            this.componentInputId = `extendable-tag-list--${uniqueId}`;
            this.formName = `tagForm_${uniqueId}`;

            //basic checks of our min, max values
            if (!this.maxTagLength || !this.minTagLength) {
                throw 'Extendable Tag List - Invalid parameters';
            }

            _.each(this.tags, t => {
                this.tagLists.predefined.push(new Tag(t, false));
            });

            //sometimes our model will be set and may contain non-predefined tags, these need to be added to the
            //user defined list
            if (this.model && this.model.length > 0) {
                const userTags = _.difference(this.model, this.tags);
                _.each(userTags, t => { this.addTagToUserDefinedList(t); });
            }

            if (this.analyticsTag) {
                $scope.$watchCollection('twi.model', (n: string[], o: string[]) => {
                    if (n && o && (n.length > 0 || o.length > 0)) {

                        let changes = _.difference(n, o);
                        //we are only interested in additions
                        if (changes.length) {
                            _.each(changes, c => {
                                let userDefined = _.findIndex(this.tagLists.userDefined, t => t.title === c) > -1;
                                this.analytics.track('mixpanel',
                                    `${this.analyticsTag}_Add`,
                                    { value : c, userDefined : userDefined });
                            });
                        }
                    }
                });
            }
        }

        public addUserTag (form) :void {
            form.$setSubmitted();

            if (!form.$valid) {
                return;
            }

            //check we don't already have it in the predefined list (if we do just select it)
            let tag = _.find(this.tagLists.predefined, t => t.title.toLowerCase() === this.newTagTitle.toLowerCase());

            if (tag) {
                if(!_.find(this.model, t => t === tag.title)) {
                    this.model.push(tag.title);
                }
                return;
            }

            //add it to our user defined list instead
            if (this.addTagToUserDefinedList(this.newTagTitle)) {
                this.model.push(this.newTagTitle); //also update our model
            }

            //clear our value and make sure the form is returned to a clean state
            this.newTagTitle = '';
            form.$setPristine();
            form.$setUntouched();

        }

        public removeUserTag(title :string) :void {
            let titleLowercase = title.toLowerCase();
            _.remove(this.tagLists.userDefined, t => t.title.toLowerCase() === titleLowercase);
            _.remove(this.model, t => t.toLowerCase() === titleLowercase);
        }

        public tagLimitReached() :boolean {
            return this.tagLists.userDefined.length >= this.maxExtraTags;
        }

        public $postLink() {
            //set our form correctly as it is dynamically named
            this.form = this.$scope[this.formName];
        };

        //adds a tag with the given title to the tags.userDefined list if it does not exist already. Returns a bool
        //indicating if anything was added
        private addTagToUserDefinedList(tagTitle :string) :boolean{
            //do we have the tag in our userdefined list? if so move on
            let tag = _.find(this.tagLists.userDefined, t => t.title.toLowerCase() === tagTitle.toLowerCase());

            if (!tag) {
                this.tagLists.userDefined.push(new Tag(tagTitle, true));
                return true;
            }

            return false;
        }

    }

    angular
        .module('core')
        .directive('extendableTagList', () => {
            return {
                restrict: 'E',
                template:   `<div>
                                <div class="u-grid-gutter-y">
                                    <ul class="inline-list inline-list--sm">
                                        <li ng-repeat="tag in twi.tagLists.predefined">
                                            <label class="o-toggle">
                                                <input class="o-toggle__checkbox" 
                                                       type="checkbox" 
                                                       value="tag.title"
                                                       checkbox-array="twi.model" /> 
                                                <span class="o-toggle__caption">{{::tag.title}}</span>
                                            </label>
                                        </li><li ng-repeat="tag in twi.tagLists.userDefined">
                                            <label class="sc-c-pill" ng-click="twi.removeUserTag(tag.title)">
                                                <span class="">{{::tag.title}}</span>
                                                <i class="icon-close sc-c-pill__close"></i>
                                            </label>
                                        </li>
                                    </ul>
                                </div>

                                <ng-form name="{{::twi.formName}}"
                                      class="sc-c-form-layout sc-c-form-layout--horizontal"
                                      data-isolate-form
                                      ng-show="!twi.tagLimitReached()">
                                    <div class="form-component">
                                        <label class="form-component__label" for="{{::twi.componentInputId}}">
                                            {{::twi.labelText}}
                                        </label>
                                        <div class="form-component__control">
                                            <input  class="form-component__input"
                                                    id="{{::twi.componentInputId}}" 
                                                    name="tag"
                                                    ng-maxlength="{{::twi.maxTagLength}}"
                                                    ng-minlength="{{::twi.minTagLength}}"
                                                    ng-model="twi.newTagTitle"
                                                    required
                                                    type="text" />
                                            <button class="sc-c-button
                                                            sc-c-button--primary
                                                            sc-c-button--hollow 
                                                            sc-c-button--round"
                                                    ng-click="twi.addUserTag(twi.form)"
                                                    type="button" >
                                                <i class="icon-plus sc-c-button__icon" />
                                            </button>
                                            <div ng-show="twi.form.$submitted" >
                                                <div class="u-error-message" 
                                                      ng-show="twi.form.tag.$error.minlength 
                                                                || twi.form.tag.$error.maxlength">
                                                    Please ensure your entry is between {{::twi.minTagLength}} and 
                                                    {{::twi.maxTagLength}} characters
                                                </div>
                                                <div class="u-error-message"
                                                      ng-show="twi.form.tag.$error.required">Please enter a value</div>
                                            </div>
                                        </div>
                                    </div>
                                </ng-form>
                                <div ng-show="twi.tagLimitReached()">
                                    You are allowed to specify a maximum of {{::twi.maxExtraTags}} tags, you'll have 
                                    to remove tags before being able to add more.
                                </div>
                            </div>`,
                bindToController: {
                    analyticsTag: '@', //DK: this will hopefully be temporary while we measure interaction with this
                    inputLabelText: '@',
                    maxExtraTags: '=',
                    maxTagLength: '@',
                    minTagLength: '@',
                    model: '=',
                    labelText: '@',
                    tags: '<'
                },
                scope: {},
                replace: true,
                controllerAs: 'twi',
                controller: ExtendableTagList
                };
        });

}
